import React, { useEffect, useState, useLayoutEffect } from "react";
import { NavLink } from "react-router-dom";
import ItemsCarousel from "react-items-carousel";

import "./SliderComponent.css";
import Pfeilzeichen from "../../img/svg/Pfeilzeichen.svg";

import { createImageChildren } from "./SliderItem";

function SliderComponent(props) {
  const {
    big,
    contentType,
    recentlyViewed,
    parentCallback,
    sliderHeadline,
    userRights,
    isStupro,
    sliderAllesAnzeigenHeadline,
  } = props;

  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const [chevronWidth, setChevronWidth] = useState(45);
  const [noOfChildren, setNoOfChildren] = useState(20);
  const [numberOfCards, setNumberOfCards] = useState(5);
  const [slidesToScroll, setSlideToScroll] = useState(5);
  const [componentProps, setComponentProps] = useState({
    infiniteLoop: true,
    gutter: 8,
    activePosition: "left",
    disableSwipe: false,
    alwaysShowChevrons: false,
    outsideChevron: true,
    showSlither: false,
    firstAndLastGutter: false,
  });
  const [isLoaded, setIsLoaded] = useState(false);
  const [projectData, setProjectData] = useState([
    {
      projekt_ID: "",
      projekt_titel: "",
      untertitel: "",
      rechte_ring: null,
      stupro_ID: null,
      medianight_semester: "",
    },
  ]);
  const [error, setError] = useState(null);
  const [windowWidth, setWindowWidth] = useState(
    window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
  );
  const [uibreakpoints, setUibreakpoints] = useState({
    phone: 600,
    phoneLarge: 769,
    tablet: 960,
    desktop: 1440,
    desktopMedium: 1680,
    desktopLarge: 1920,
  });
  const [showChevron, setShowChevron] = useState(false);

  function formatQueryParams(projektParams) {
    let pString = "&projekt_ID=";
    if (projektParams > "" && projektParams !== undefined) {
      for (let i = 0; i <= projektParams.length - 1; i++) {
        if (i === projektParams.length - 1 && i !== 0) {
          pString += `%2C${projektParams[i]}`;
        } else {
          i >= 1
            ? (pString += `%2C${projektParams[i]}`)
            : (pString += projektParams[i]);
        }
      }
      return pString;
    }
    return "";
  }

  function getContentType(type, recentlyViewed) {
    const sql_query = `${process.env.REACT_APP_API}/`;
    const dtml_method = type;
    const params = formatQueryParams(recentlyViewed);
    const value = sql_query + dtml_method + params;
    return value;
  }

  useEffect(() => {
    const projectsQuery = getContentType(contentType, recentlyViewed);

    fetch(projectsQuery)
      .then((response) => response.json())
      .then(
        (result) => {
          if (big) {
            setIsLoaded(true);
            setProjectData(result);
            setNoOfChildren(15);
          } else {
            setIsLoaded(true);
            setProjectData(result);
            setNoOfChildren(result.length);
          }
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }, []);

  useLayoutEffect(() => {
    function updateLayout() {
      setLayout(big, window.innerWidth);
    }

    window.addEventListener("resize", updateLayout);
    window.addEventListener("load", updateLayout);
    updateLayout();
    return function cleanup() {
      window.removeEventListener("resize", updateLayout);
      window.removeEventListener("load", updateLayout);
    };
  }, []);

  function setLayout(isBig, windowWidth) {
    if (windowWidth < uibreakpoints.phone) {
      setChevronWidth(15);

      if (isBig) {
        setNumberOfCards(1);
        setSlideToScroll(1);
      } else {
        setNumberOfCards(2);
        setSlideToScroll(2);
      }
    } else if (
      windowWidth > uibreakpoints.phone &&
      windowWidth < uibreakpoints.phoneLarge
    ) {
      setChevronWidth(25);

      if (isBig) {
        setNumberOfCards(2);
        setSlideToScroll(2);
      } else {
        setNumberOfCards(3);
        setSlideToScroll(3);
      }
    } else if (
      windowWidth > uibreakpoints.phoneLarge &&
      windowWidth < uibreakpoints.tablet
    ) {
      setChevronWidth(45);
      if (isBig) {
        setNumberOfCards(3);
        setSlideToScroll(3);
      } else {
        setNumberOfCards(4);
        setSlideToScroll(4);
      }
    } else if (
      windowWidth > uibreakpoints.tablet &&
      windowWidth < uibreakpoints.desktop
    ) {
      if (isBig) {
        setNumberOfCards(3);
        setSlideToScroll(3);
      } else {
        setNumberOfCards(4);
        setSlideToScroll(4);
      }
    } else if (
      windowWidth > uibreakpoints.desktop &&
      windowWidth < uibreakpoints.desktopMedium
    ) {
      if (isBig) {
        setNumberOfCards(4);
        setSlideToScroll(4);
      } else {
        setNumberOfCards(5);
        setSlideToScroll(5);
      }
    } else if (
      windowWidth > uibreakpoints.desktopMedium &&
      windowWidth < uibreakpoints.desktopLarge
    ) {
      if (isBig) {
        setNumberOfCards(5);
        setSlideToScroll(5);
      } else {
        setNumberOfCards(7);
        setSlideToScroll(7);
      }
    } else if (isBig) {
      setNumberOfCards(6);
      setSlideToScroll(6);
    } else {
      setNumberOfCards(8);
      setSlideToScroll(8);
    }
  }

  function requestChangeURL(value) {
    passChangedProjectIdToParent(value);
  }

  function passChangedProjectIdToParent(passedID) {
    if (parentCallback) {
      parentCallback(passedID);
    }
  }

  function handleShowChevron() {
    if (showChevron) {
      setShowChevron(false);
    } else if (!showChevron) {
      setShowChevron(true);
    }
  }

  // Hier werden die einzelnen Kacheln erzeugt --> die Funktion createImageChildren liegt in SliderItem.js
  const children = createImageChildren(
    noOfChildren,
    projectData,
    numberOfCards,
    requestChangeURL,
    userRights,
    contentType
  );

  if (error) {
    return <p style={{ color: "white" }}>{error.message}</p>;
  }
  if (!isLoaded) {
    return (
      <div className="sl-slider-container">
        <div
          style={{
            padding: `0 ${chevronWidth}px`,
            marginTop: "40px",
            height: "100%",
          }}
        >
          <div className="dynamic-loader-container">
            <div className="dynamic-loader">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div
      className="sl-slider-container"
      onMouseEnter={() => handleShowChevron()}
      onMouseLeave={() => handleShowChevron()}
    >
      <div style={{ padding: `0 ${chevronWidth}px`, marginTop: "40px" }}>
        <div className="headline-slider-div">
          <h2 className="sl-slider-headline">{sliderHeadline}</h2>
          {isStupro ? (
            <NavLink
              exact
              to={`/mediathek/allesanzeigen/${contentType}`}
              className="alles-anzeigen-headline"
            >
              {sliderAllesAnzeigenHeadline}
            </NavLink>
          ) : null}
        </div>
        <ItemsCarousel
          {...componentProps}
          numberOfCards={numberOfCards}
          slidesToScroll={slidesToScroll}
          classes={{
            wrapper: "sl-wrapper",
            itemsWrapper: "sl-itemsWrapper",
            itemsInnerWrapper: "sl-itemsInnerWrapper",
          }}
          requestToChangeActive={(value) => setActiveItemIndex(value)}
          activeItemIndex={activeItemIndex}
          leftChevron={
            (big && numberOfCards > 2) || numberOfCards > 3 ? (
              <button
                className="sl-chevronButton"
                style={
                  showChevron
                    ? { opacity: "1", transition: "0.5s ease" }
                    : { opacity: "0", transition: "0.5s ease" }
                }
              >
                <img
                  src={Pfeilzeichen}
                  tabIndex={1}
                  aria-label="Im Slider nach Links navigieren"
                  alt="Im Slider nach Links navigieren"
                  className="chevron-icon-left"
                />
              </button>
            ) : null
          }
          rightChevron={
            (big && numberOfCards > 2) || numberOfCards > 3 ? (
              <button
                className="sl-chevronButton"
                style={
                  showChevron
                    ? { opacity: "1", transition: "0.5s ease" }
                    : { opacity: "0", transition: "0.5s ease" }
                }
              >
                <img
                  src={Pfeilzeichen}
                  tabIndex={1}
                  aria-label="Im Slider nach Rechts navigieren"
                  alt="Im Slider nach Rechts navigieren"
                  className="chevron-icon-right"
                />
              </button>
            ) : null
          }
          outsideChevron
          chevronWidth={chevronWidth}
          children={children}
        />
      </div>
    </div>
  );
}

export default SliderComponent;
